import request from '@/middleware/request'

const getField = () => {
  return request({
    url: '/fields/list',
    method: 'get'
  })
}

const getGroup = () => {
  return request({
    url: '/fields/group',
    method: 'get'
  })
}

const activeField = () => {
  return request({
    url: '/fields/active',
    method: 'get'
  })
}

const createField = data => {
  return request({
    url: '/fields',
    method: 'post',
    data
  })
}

const updateField = (id, data) => {
  return request({
    url: `/fields/${id}`,
    method: 'patch',
    data
  })
}

const deleteField = id => {
  return request({
    url: `/fields/${id}`,
    method: 'delete'
  })
}

export default {
  getField,
  getGroup,
  activeField,
  createField,
  updateField,
  deleteField
}
